"use client";

import Image from "next/image";
import { Typography } from "@/components/Typography";
import { FALLBACK_FEATURE_IMAGE } from "@/lib/utils";

type Badge = { textColor?: string; backgroundColor?: string };

type SearchResultItemProps = {
  name: string;
  located?: string;
  thumbnail?: string;
  badge?: Badge;
  badgeLabel: string;
  onClick: () => void;
};

export function SearchResultItem({
  name,
  located,
  thumbnail,
  badge,
  badgeLabel,
  onClick,
}: SearchResultItemProps) {
  return (
    <button
      type="button"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      className="flex w-full items-center justify-between p-1 rounded-lg hover:bg-subtle card-hover transition-colors"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Image
          src={thumbnail ?? FALLBACK_FEATURE_IMAGE}
          alt={name}
          width={40}
          height={40}
          className="h-10 w-10 shrink-0 rounded-md border object-cover"
        />
        <div className="flex flex-col min-w-0 flex-1 text-start">
          <Typography variant="subtitle2" className="truncate">
            {name}
          </Typography>
          <Typography variant="body-xs" className="text-caption truncate">
            {located}
          </Typography>
        </div>
      </div>

      <Typography variant="body-xs">
        <span
          className="shrink-0 rounded-full px-2 py-1"
          style={{ color: badge?.textColor, backgroundColor: badge?.backgroundColor }}
        >
          {badgeLabel}
        </span>
      </Typography>
    </button>
  );
}